import clsx from 'clsx';

import { ContainedTable, ContainedTableProps } from '../ContainedTable/ContainedTable';

import styles from './CardTable.module.scss';


export function CardTable({
    className, tableClassName, slim, ...otherProps
}: ContainedTableProps & { slim?: boolean }) {
    return (
        <ContainedTable
            className={clsx(styles.root, className)}
            tableClassName={clsx(styles.cardTable, tableClassName, {
                [styles.slim]: slim
            })}
            {...otherProps}
        />
    );
}
